export default __webpack_public_path__ + "imgs/8e6753b30fdbb29c508e49facd495fc9.png";